import { projectStatusLabels } from '../sections/statusLabels';

export interface StatusTone {
  /** Pill text. */
  fg: string;
  /** Pill background. */
  bg: string;
  /** Bar segment, legend swatch, pill dot, progress fill. */
  bar: string;
}

/**
 * Project status palette from the dashboard design. Fixed across themes
 * except `active`, which follows the tenant brand. Values are CSS variables
 * declared in dashboard.css — never hex here.
 */
const TONES: Record<string, StatusTone> = {
  active: { fg: 'var(--dash-brand)', bg: 'var(--dash-brand-soft)', bar: 'var(--dash-brand)' },
  draft: { fg: 'var(--dash-status-draft-fg)', bg: 'var(--dash-status-draft-bg)', bar: 'var(--dash-status-draft-bar)' },
  on_hold: { fg: 'var(--dash-amber-ink)', bg: 'var(--dash-amber-soft)', bar: 'var(--dash-amber)' },
  completed: { fg: 'var(--dash-green-ink)', bg: 'var(--dash-green-soft)', bar: 'var(--dash-green)' },
  cancelled: { fg: 'var(--dash-status-closed-fg)', bg: 'var(--dash-status-closed-bg)', bar: 'var(--dash-status-closed-bar)' },
};

/** Display order for tabs and the distribution legend. */
export const PROJECT_STATUS_ORDER = ['active', 'draft', 'on_hold', 'completed', 'cancelled'];

// Legacy rows can still carry `in_progress`; it reads as ongoing work.
export const projectStatusTone = (status: string): StatusTone =>
  TONES[status] || (status === 'in_progress' ? TONES.active : TONES.draft);

export const projectStatusLabel = (status: string, isRTL: boolean): string =>
  projectStatusLabels(isRTL)[status] || status;

/**
 * Known statuses in display order, then any other status that actually has
 * rows (so an off-choice value is counted, never dropped).
 */
export const projectStatusKeys = (byStatus: Record<string, number>): string[] => [
  ...PROJECT_STATUS_ORDER,
  ...Object.keys(byStatus).filter((k) => !PROJECT_STATUS_ORDER.includes(k) && (byStatus[k] ?? 0) > 0),
];
